import React from "react";
import { useParams } from "react-router-dom";

const PERSONAL_DATA = btoa("quizbee_personalinfo");
const LOCAL_STORE = "quizbee_test";

const localStore = {
    get(key) {
        try {
            const store = JSON.parse(localStorage.getItem(key))
            if (!store) throw new Error("No Data Found");
            return store;
        } catch {
            return null;
        }
    },
    set(key, data) {
        try {
            localStorage.setItem(key, JSON.stringify(data))
        } catch {}
    }
}


const getStoreKey = (quizName) => {
    if (!quizName) throw new Error("Store Key is required");
    return btoa(`${LOCAL_STORE}_${quizName}`.toLowerCase())
};

const getStore = (quizName) => {
    const personalInfo = localStore.get(PERSONAL_DATA);
    const testStore = localStore.get(getStoreKey(quizName));

    if (!personalInfo) { return testStore };

    return {
        ...testStore,
        personalInfo,
    }
};

const setStore = (quizName, { personalInfo, ...data}) => {
    localStore.set(PERSONAL_DATA, personalInfo)
    localStore.set(getStoreKey(quizName), data)
};



const getCleanState = (quizName) => {
    const state = getStore(quizName);
    if (!state) return state;

    return {
        ...state,
        quizProgress: null
    }
}

const AppContext = React.createContext({});

const AppContextProvider = React.memo((props) => {
    const {quizName}= useParams(),
          [progress, setProgress] = React.useState(() => getCleanState(quizName));

    
    React.useEffect(() => {
        setProgress(getCleanState(quizName));
    }, [quizName])
    

    const updateUserProgress = React.useCallback((progress) => {
        setProgress(progress);
        setStore(quizName, progress);
    }, [quizName, setProgress]);

    const value = React.useMemo(() => ({ updateUserProgress, progress }), [progress]);
    
    return (
        <AppContext.Provider { ...props } value={value}>
            <React.Fragment key={quizName}>{ props.children }</React.Fragment>
        </AppContext.Provider>
    )
});


export default AppContextProvider;

export const getAppContext = () => AppContext;
